$(function(){
	$('.table-mob .entete').click(function(){
		$(this).parent('.item').toggleClass('open');
	});
});